import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventRcsVideoUploaded, useEventRcsVideoUploadError } from 'entities/Rcs'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import { RcsWizardStore } from 'pages/settings/pages/rcsV2/store/rcsWizardStore'

import styles from './styles.module.scss'

const RcsWizardContext = createContext<RcsWizardStore | null>(null)

export const useRcsWizardContext = () => {
  const context = useContext(RcsWizardContext)

  if (context === null) {
    throw new Error('You have forgotten to wrap with RcsWizardProvider')
  }

  return context
}

export const RcsWizardProvider = observer(({ children }: { children: ReactNode }) => {
  const entities = useEntitiesContext()
  const presentationStore = usePresentationModeContext()
  const [store] = useState(() => new RcsWizardStore(entities, presentationStore))

  useEffect(() => store.dispose, [])

  useEventRcsVideoUploaded(store.useCaseStore.onVideoUploaded)
  useEventRcsVideoUploadError(store.useCaseStore.onVideoUploadError)

  return (
    <RcsWizardContext.Provider value={store}>
      {store.loading ? (
        <FullPageWrapper className={styles.loading}>
          <SpinnerLoader ariaLabel={'RcsWizardProvider'} />
        </FullPageWrapper>
      ) : (
        children
      )}
    </RcsWizardContext.Provider>
  )
})
